import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.link.js";
import React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui';
import Box from 'components/Box';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import Text from 'components/Text';
import UserBadgeImage from 'components/UserBadgeImage';
import UserGeneratedText from 'components/UserGeneratedText';
import { ActionMenu, IconsAndMenuBox, CardLink, Image, Subtitle, getCardTitleId, getCardSubtitleId, getCardDescriptionId, getCardMenuId } from '../shared';
var BillboardContent = styled(Flex).withConfig({
  displayName: "Billboard__BillboardContent",
  componentId: "sc-vgqams-0"
})(["position:relative;display:flex;flex-direction:column;align-items:flex-start;padding:", " ", ";@media (min-width:", "){width:32%;min-width:", ";flex:none;padding-top:", ";}@media (min-width:", "){padding-left:", ";padding-right:", ";}"], function (p) {
  return p.theme.globals.spacing.s;
}, function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.breakpoints.xs;
}, pxToRem(320), function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.breakpoints.s;
}, function (p) {
  return p.theme.globals.spacing.l;
}, function (p) {
  return p.theme.globals.spacing.l;
});
var BillboardImageWrapper = styled.div.withConfig({
  displayName: "Billboard__BillboardImageWrapper",
  componentId: "sc-vgqams-1"
})(["display:flex;width:100%;overflow:hidden;border-radius:", ";border-bottom-left-radius:0;@media (max-width:", "){border-bottom-right-radius:0;}@media (min-width:", "){border-top-left-radius:0;}"], function (p) {
  return pxToRem(p.theme.globals.borderRadius.large);
}, function (p) {
  return p.theme.globals.breakpoints.xs;
}, function (p) {
  return p.theme.globals.breakpoints.xs;
});
var BadgeContainer = function BadgeContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    breakpoints: "xs"
    // On mobile, float next to title
    ,
    float: ['right', 'none'],
    mt: [-44, 0],
    ml: ['xxs', 0],
    mr: ['-xs', 0]
    // On Desktop, position absolutely
    ,
    position: ['relative', 'absolute'],
    bottom: [null, 'xs'],
    right: [null, -30],
    z: "raised"
  }, children);
};
var Billboard = function Billboard(_ref2) {
  var infoIcons = _ref2.infoIcons,
    description = _ref2.description,
    icon = _ref2.icon,
    id = _ref2.id,
    imageSource = _ref2.imageSource,
    menuItems = _ref2.menuItems,
    priorityPill = _ref2.priorityPill,
    link = _ref2.link,
    title = _ref2.title,
    subtitle = _ref2.subtitle,
    badge = _ref2.badge,
    _ref2$hasUserBadge = _ref2.hasUserBadge,
    hasUserBadge = _ref2$hasUserBadge === void 0 ? false : _ref2$hasUserBadge;
  var titleId = getCardTitleId(id);
  var subtitleId = getCardSubtitleId(id);
  var descriptionId = getCardDescriptionId(id);
  var menuId = getCardMenuId(id);
  return /*#__PURE__*/React.createElement(Card, {
    "data-testid": "billboard",
    as: "article",
    "aria-labelledby": titleId,
    variant: "clickable",
    position: "relative",
    display: "flex",
    flexDirection: ['column', 'row-reverse'],
    breakpoints: "xs"
  }, /*#__PURE__*/React.createElement(BillboardImageWrapper, null, /*#__PURE__*/React.createElement(Image, {
    aspectRatio: 1 / 2,
    maxHeight: 320,
    link: link,
    icon: icon,
    src: imageSource
  })), /*#__PURE__*/React.createElement(BillboardContent, null, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    width: "100%"
  }, badge && !badge.isDeleted && /*#__PURE__*/React.createElement(BadgeContainer, null, /*#__PURE__*/React.createElement(UserBadgeImage, {
    badge: badge,
    hasUserBadge: hasUserBadge,
    size: 60
  })), priorityPill && /*#__PURE__*/React.createElement(Box, {
    ml: "-xxs",
    mb: "xxs"
  }, priorityPill), /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    id: titleId,
    mb: "xxs"
  }, /*#__PURE__*/React.createElement(CardLink, {
    link: link
  }, title)), /*#__PURE__*/React.createElement(Subtitle, {
    id: subtitleId
  }, subtitle), description && /*#__PURE__*/React.createElement(Text, {
    id: descriptionId,
    mt: ['s', 'l'],
    breakpoints: "xs",
    overflow: "wrap",
    as: "div"
  }, /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: description,
    truncateLength: 160,
    allowLineBreaks: false
  }))), /*#__PURE__*/React.createElement(IconsAndMenuBox, {
    mt: "xs"
    // If there's a badge, we need to make space for it on desktop
    ,
    mr: ['-xs', badge ? 's' : '-s'],
    breakpoints: "xs"
  }, /*#__PURE__*/React.createElement(Flex, {
    align: "top"
  }, infoIcons, menuItems && /*#__PURE__*/React.createElement(ActionMenu, {
    items: menuItems,
    id: menuId,
    titleId: titleId
  })))));
};
export default Billboard;